import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject, ChangeDetectorRef, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { PatientService } from '@service/patient.service';
import { FormControl, Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { Patient } from '@models/appointments/patient.model';
import { AuthService } from '@service/auth.sevice';
import { AuthTokenHelper } from '@helpers/auth-token-helper';
import { HttpBaseService } from '@service/http-base.service';
import { BeyondEMRConstants } from '@helpers/beyondemrconstants';
import { MatSelect } from '@angular/material/select';
import { BeyondEMRHelper } from '@helpers/beyondemr-helper';
import { RoutingHelper } from '@helpers/routinghelper';

@Component({
  selector: 'app-basic-form',
  templateUrl: './basic-form.component.html',
  styleUrls: ['./basic-form.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})

export class BasicFormComponent {
  patientDetail: Patient;
  public action: string;
  public dialogTitle: string;
  providerTypeForm: FormGroup;
  isActive = false;
  disabled = false;
  SuffixMaster: any[];
  apiURL: string;
  token: string;
  dbName: string;
  suffix: string;
  requiredExpiryDate: boolean = false;
  close: any;
  minDate: Date;
  isDisabled: boolean = false;
  @ViewChild(MatSelect) matSelect: MatSelect;
  defaultPOCChecked?: boolean = true;

  constructor(private cdf: ChangeDetectorRef,
    public dialogRef: MatDialogRef<BasicFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private httpService: HttpBaseService,
    public patientService: PatientService,
    private fb: FormBuilder,
    private router: Router,
    private authHelper?: AuthTokenHelper,
    private authService?: AuthService,
    private helper?: BeyondEMRHelper,
    private routingHelper?: RoutingHelper,
  ) {
    // Set the defaults
    this.action = data.action;
    this.token = this.authHelper.GetAuthorizationTokenValue();
    this.httpService.getAPIURL().subscribe(url => {
      this.apiURL = `${url.API_URL}`;
      this.getSuffixMaster();
    });
    this.dialogTitle = 'New Patient';
    this.patientDetail = new Patient();
    this.providerTypeForm = this.createForm();
    dialogRef.disableClose = true;

    let tokenResult = this.authService.getDecodedAccessToken(this.token);
    this.minDate = new Date();

    this.dbName = tokenResult ? tokenResult["DataBase"] : "BeyondEMR";
    this.defaultPOCChecked = true;
  }

  onCheckBoxValueChange(isCheckboxChecked) {
    if (isCheckboxChecked == true) {
      this.defaultPOCChecked = true;
    }
    else {
      this.defaultPOCChecked = false;
    }
  }


  getSuffixMaster() {
    this.patientService.getSuffixMaster(this.apiURL + 'masters/GetAllSuffix').subscribe(data => {
      if (data) {
        this.SuffixMaster = data;
      }
    });
  }

  formControl = new FormControl('', [
    Validators.required
    // Validators.email,
  ]);

  getErrorMessage() {
    return this.formControl.hasError('required')
      ? 'Required field'
      : this.formControl.hasError('email')
        ? 'Not a valid email'
        : '';
  }

  createForm(): FormGroup {
    return this.fb.group({
      Id: 0,
      FirstName: '',
      MiddleName: '',
      LastName: '',
      PhoneNumber: '',
      Suffix: '',
      EmailId: '',
      Active: true,
      DOB: '',
      InsuranceNumber: '',
      PasswordType: 2,
      PasswordExpiryDate: '',
    });
  }

  submit() {
    // emppty stuff
  }
  
  onNoClick(): void {
    this.dialogRef.close();
  }

  public confirmAdd(): void {
    this.isDisabled = true;
    let patient = this.providerTypeForm.getRawValue();
    this.bindPatient(patient);
    var token= this.authHelper.GetAuthorizationTokenValue();
    var userToken = this.authService.getDecodedAccessToken(token);
    this.patientDetail.SubscriberId = userToken.SubscriberId;
    this.patientDetail.ProfileAttachment = null;
    this.patientDetail.AdditionalDetail.StatusId = BeyondEMRConstants.STATUS.Patient_Pending;
    this.patientDetail.DefaultPOCTemplate = this.defaultPOCChecked;
    this.patientService.addPatient('patient/create', this.patientDetail).subscribe(data => {
      if (data) {
        this.helper.showNotification('Patient Record is ' + 'Created' + ' Successfully...!!!');
        let id = this.routingHelper.EncodeParam(data);
        this.router.navigate(['/patients/patient/edit/' + id]);
      }
    });
    this.dialogRef.close(true);
  }

  public sendEmail() {
    this.isDisabled = true;
    let patient = this.providerTypeForm.getRawValue();
    this.bindPatient(patient);
    var token= this.authHelper.GetAuthorizationTokenValue();
    var userToken = this.authService.getDecodedAccessToken(token);
    this.patientDetail.SubscriberId = userToken.SubscriberId;
    this.patientDetail.IsPatientIntake = true;
    this.patientDetail.AdditionalDetail.StatusId = BeyondEMRConstants.STATUS.Patient_Intake;
    this.patientDetail.DefaultPOCTemplate = this.defaultPOCChecked;
    this.patientService.addPatient('patient/create', this.patientDetail).subscribe(data => {
      // if (data) {
      //   var url = btoa(this.dbName + ";" + data);
      //   this.patientService.sendPatientIntake(this.apiURL + 'patient/SendIntakeEmail', url, data).subscribe(res => {
      //     this.dialogRef.close(true);
      //   });
      // }
    });
    this.dialogRef.close(true);
  }

  bindPatient(patient) {
    this.patientDetail.Contact.FirstName = patient.FirstName;
    this.patientDetail.Contact.LastName = patient.LastName;
    this.patientDetail.Contact.MiddleName = patient.MiddleName;
    this.patientDetail.Contact.Suffix = patient.Suffix;
    this.patientDetail.Contact.MobilePhone = patient.PhoneNumber;
    this.patientDetail.Contact.EmailId = patient.EmailId;
    this.patientDetail.Contact.ContactTypeId = 5;
    this.patientDetail.DOB = patient.DOB;
    this.patientDetail.InsuranceNumber = patient.InsuranceNumber;
    this.patientDetail.AdditionalDetail.PasswordExpiryDate = patient.PasswordExpiryDate;
    this.patientDetail.AdditionalDetail.PasswordType = patient.PasswordType;
  }

  //auto populate sections need to made as generic component
  onChangeSuffix(item) {
    this.patientDetail.Contact.Suffix = item;
  }

  ngAfterViewInit() {
    this.matSelect.openedChange.subscribe(opened => {
      if (opened) {
        this.matSelect.panel.nativeElement.addEventListener('mouseleave', () => {
          this.matSelect.close();
        })
      }
    })

  }
}
